import { render, staticRenderFns } from "./ProductNew.vue?vue&type=template&id=d0d12698&scoped=true"
import script from "./ProductNew.vue?vue&type=script&lang=ts"
export * from "./ProductNew.vue?vue&type=script&lang=ts"
import style0 from "./ProductNew.vue?vue&type=style&index=0&id=d0d12698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d12698",
  null
  
)

export default component.exports